import { useMutation } from "react-query";
import getInvestorFunds from "../services/getInvestorFunds";


const useInvestorFunds = () => {
    return useMutation(["investor-funds"], getInvestorFunds);
  };

export default useInvestorFunds;